module.exports = __webpack_public_path__ + "static/media/img_preview@3x.cfb5929b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@3x/img_preview@3x.png
// module id = 943
// module chunks = 0